// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6001) return "static/chunks/6001.4db320f1e9505472.js";
	if (chunkId === 9322) return "static/chunks/9322.96e9b487f022b07d.js";
	if (chunkId === 2007) return "static/chunks/2007.288d5163e85914d8.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3473 ? "891cff7f" : chunkId) + "-" + {"1732":"344e7d61ed1ef9c1","3473":"b4ab3287890d43a4","8042":"f9d5af539125161a","9817":"44c458179d031371"}[chunkId] + ".js";
};